// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"58579f40","232":"93039971","348":"a56c15fb","391":"c5717473","490":"ae1fbeab","516":"f1ba9abd","667":"84603475","826":"92912c4c"}[chunkId] + ".chunk.js";
};